import type { ReceiptTemplate } from '../schema';

export const iphoneTemplate: ReceiptTemplate = {
  id: 'iphone',
  name: 'iPhone Receipt',
  brand: 'APPLE',
  description: 'Apple Store iPhone receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ip-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'APPLE STORE',
        businessNameFontSize: 18,
        addressLines: ['1200 DARK AVENUE', 'MONSTERVILLE, CA 94608'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ip-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: 'W847291034' },
          { id: 'specialist', label: 'Specialist:', value: 'Mike W.' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ip-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'IPHONE 15 PRO 256GB NATURAL', quantity: '1', price: '1099.00', sku: '' },
          { id: '2', name: 'APPLECARE+ FOR IPHONE', quantity: '1', price: '199.00', sku: '' },
          { id: '3', name: 'SILICONE CASE BLACK', quantity: '1', price: '49.00', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ip-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '1347.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '111.13', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '1458.13', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ip-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'APPLE PAY', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'ip-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'THANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

